import { useState, useEffect } from 'react';
import { BlogPost, blogPosts as staticPosts } from '../data/blogPosts';
import { sanityClient } from '../sanity/client';

const GROQ = `*[_type == "post" && published == true && publishedAt <= now()] | order(publishedAt desc) {
  "id": _id,
  title,
  "slug": slug.current,
  "date": publishedAt,
  "excerpt": excerpt,
  "coverImage": coverImage.asset->url,
  tags,
  "content": body
}`;

export async function fetchFromSanity(): Promise<BlogPost[]> {
  const posts = await sanityClient.fetch<BlogPost[]>(GROQ);
  return posts.map(p => ({
    ...p,
    date: p.date ? p.date.slice(0, 10) : '',
    author: 'Eliane Forti Fernandes',
    tags: p.tags ?? [],
  }));
}

declare global {
  interface Window {
    __POSTS__?: BlogPost[];
  }
}

// Posts já buscados no build (pré-render): evitam o esqueleto de carregamento e vão no HTML
let postsPreRender: BlogPost[] | undefined;
export const definirPostsPreRender = (posts: BlogPost[]) => {
  postsPreRender = posts;
};

export function useBlogPosts() {
  const [iniciais] = useState(() => postsPreRender ?? (typeof window !== 'undefined' ? window.__POSTS__ : undefined));
  const [posts, setPosts] = useState<BlogPost[]>(iniciais ?? staticPosts);
  const [loading, setLoading] = useState(!iniciais);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    fetchFromSanity()
      .then(fetched => {
        if (cancelled) return;
        if (fetched.length > 0) setPosts(fetched);
        setLoading(false);
      })
      .catch(err => {
        if (cancelled) return;
        console.warn('Sanity indisponível, usando fallback:', err);
        setError('fallback');
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  return { posts, loading, error };
}
